import classes from 'components/widgets/Trends/components/Filters/Filters.module.scss';
import { RadioComponent } from 'components/common/RadioComponent/radioComponent';
import { MyCustomSelect } from 'components/common';
import { InputOption, ValueContainer } from 'components/common/MyCustomSelect/myCustomSelect';
import { MuiIcon } from 'components/common/muiIcon/muiIcon';
import React from 'react';
import { SingleLineOptions } from 'components/widgets/Trends/components/TrendsGraph/TrendsGraph';

export const Filters = ({ sourceData, handleSingle, options, handleSelectOptions }) => {
    const isMultiple = sourceData.singleLine === 'Multi Parameters (Normalized values)';
    const isNote = sourceData.selectedOptions?.note;

    const controlProps = (item: SingleLineOptions) => ({
        checked: sourceData.singleLine === item,
        onChange: handleSingle,
        value: item,
        name: 'show-option',
    });
    return (
        <div className={classes.selectParametersWrapper}>
            <div className={classes.radiosRow}>
                <span>Show: </span>
                <div className={classes.radioContainer}>
                    <label>
                        <RadioComponent {...controlProps('Pre-defined Combinations (Normalized values)')} />
                        Pre-defined Combinations (Normalized values)
                    </label>
                    <label>
                        <RadioComponent {...controlProps('Multi Parameters (Normalized values)')} />
                        Multi Parameters (Normalized values)
                    </label>
                    <label>
                        <RadioComponent {...controlProps('Single Parameter (Actual value)')} />
                        Single Parameter (Actual value)
                    </label>
                </div>
            </div>
            <div data-testid={'select-row'} className={classes.selectRow}>
                <MyCustomSelect<ISelectOption<string>, typeof isMultiple>
                    value={sourceData.selectedOptions}
                    options={options}
                    onChange={handleSelectOptions}
                    closeMenuOnSelect={!isMultiple}
                    hideSelectedOptions={!isMultiple}
                    isMulti={isMultiple}
                    placeholder={'Select Items...'}
                    components={
                        isMultiple
                            ? {
                                  Option: InputOption,
                                  ValueContainer: ValueContainer,
                              }
                            : {}
                    }
                />
            </div>
            {isNote && (
                <div className={classes.lookForContainer}>
                    <MuiIcon icon={'report'} color={'#4c9bfa'} className={classes.reportIcon} />
                    {isNote}
                </div>
            )}
        </div>
    );
};
